import { IAppState } from '../../common/state';

export function getNewbuildingId({ newbuildingInformation }: IAppState): number | undefined {
  return newbuildingInformation?.id;
}
